import PropTypes from 'prop-types';
import { memo, useCallback } from 'react';
import dayjs from 'dayjs';
import dayjsPluginUTC from 'dayjs-plugin-utc';
import { useDispatch, useSelector } from 'react-redux';
import Filter from '../../../../Filters/Filter';
import Sliders from './Sliders';
import { carSearch } from '../../../../../store/slices/car';
import carSearchInput from '../../../../../helpers/selectors/carSearchInput';
import { setCarTripSearchInputs } from '../../../../../store/slices/tripSearch';

dayjs.extend(dayjsPluginUTC);

const BudgetFilter = ({ tripId, selectedTab, bgClassName }) => {
  const isTripSearch = !tripId;
  const dispatch = useDispatch();
  const {
    searchInputs, responseFilters, defaultSearchObj,
  } = useSelector(carSearchInput(tripId, selectedTab, isTripSearch));
  const isEmpty = searchInputs.fromBudget
    === defaultSearchObj.fromBudget
    && searchInputs.toBudget
    === defaultSearchObj.toBudget;

  const search = useCallback((o) => {
    if (isTripSearch) {
      dispatch(setCarTripSearchInputs({
        page: 1,
        ...o,
      }));
    } else {
      dispatch(carSearch({
        tripId,
        selectedTab,
        searchObj: {
          ...searchInputs,
          page: 1,
          ...o,
        },
      }));
    }
  }, [isTripSearch, dispatch, tripId, selectedTab, searchInputs]);

  const handleChangeBudget = useCallback((event, newValue) => {
    search({
      fromBudget: newValue[0],
      toBudget: newValue[1],
    });
  }, [search]);

  const handleClear = useCallback(() => {
    search({
      fromBudget: defaultSearchObj.fromBudget,
      toBudget: defaultSearchObj.toBudget,
    });
  }, [search, defaultSearchObj]);

  return (
    <>
      {responseFilters.minBudget && responseFilters.maxBudget && (
        <Filter
          label="Price"
          menuWidthClass="w-max"
          isFilterEmpty={isEmpty}
          variant={!isTripSearch ? 'outline' : undefined}
          filterMaxWidthClass="max-w-full"
          handleClear={handleClear}
          bgClassName={!isTripSearch ? '' : bgClassName}
        >
          <div className="p-5">
            <Sliders
              budget={[
                searchInputs.fromBudget || responseFilters.minBudget,
                searchInputs.toBudget || responseFilters.maxBudget,
              ]}
              min={responseFilters.minBudget}
              max={responseFilters.maxBudget}
              onBudgetChange={handleChangeBudget}
              currencyCode={responseFilters.currencyCode}
            />
          </div>
        </Filter>
      )}
    </>
  );
};

BudgetFilter.propTypes = {
  tripId: PropTypes.string,
  bgClassName: PropTypes.string,
  selectedTab: PropTypes.number,
};

BudgetFilter.defaultProps = {
  tripId: undefined,
  bgClassName: undefined,
  selectedTab: 0,
};

export default memo(BudgetFilter);
